export const status_convite_enviado = 'Enviado';
export const status_convite_cadastrado = 'Cadastro realizado';
export const status_convite_vencido = 'Convite vencido';

export const STATUS_CONVITE = [status_convite_enviado, status_convite_cadastrado, status_convite_vencido];

export const CORES_STATUS_CONVITE = {
    [status_convite_enviado]: 'azul',
    [status_convite_cadastrado]: 'verde',
    [status_convite_vencido]: 'vermelho',
};

export const ICONES_STATUS_CONVITE = {
    [status_convite_enviado]: 'pi-send',
    [status_convite_cadastrado]: 'pi-check-circle',
    [status_convite_vencido]: 'pi-clock',
};
